export default __webpack_public_path__ + "static/media/shape1.95355d62.svg";